
































import {Component, Prop, Vue} from "vue-property-decorator";
import {CustomerBalance} from "@/interfaces/entities/CustomerProfile";
import {isDataExhaustedBalance, isValidityExpiredBalance} from "@/util/balancePlanStatus";

@Component
export default class PreviousPlansCard extends Vue {
    @Prop({type: Array, default: () => []}) previousBalances!: Array<CustomerBalance>;

    private isConsumed(balance: CustomerBalance): boolean {
        return isDataExhaustedBalance(balance);
    }

    private isExpired(balance: CustomerBalance): boolean {
        return isValidityExpiredBalance(balance);
    }

    private countryNameFor(countrySet: string): string {
        return this.$options.filters?.countryName ? (this.$options.filters.countryName(countrySet) as string) : countrySet;
    }
}
